import { useEffect, useRef } from "react";
import SEOHead from "../components/SEOHead";

export default function Privacy() {
  const cookieDeclarationRef = useRef(null);

  useEffect(() => {
    if (cookieDeclarationRef.current) {
      // Indsæt Cookiebot CookieDeclaration scriptet dynamisk hvis det ikke findes
      if (!document.getElementById("CookieDeclaration")) {
        const script = document.createElement("script");
        script.id = "CookieDeclaration";
        script.src = "https://consent.cookiebot.com/93a9ee34-d900-483a-a921-1343384e7885/cd.js";
        script.type = "text/javascript";
        script.async = true;
        cookieDeclarationRef.current.appendChild(script);
      }
    }
  }, []);

  return (
    <>
      <SEOHead
        title="Privacy Policy - Prajwal Halwai"
        description="Privacy policy and data processing information for Prajwal Halwai (CVR 46152085), Odense, Denmark."
      />

      <section className="py-20 md:py-24 border-b border-[#181B24]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
          <span className="text-xs font-semibold uppercase tracking-wider text-[#CC3737]">
            Legal & Compliance
          </span>
          <h1 className="text-3xl sm:text-5xl font-extrabold text-white tracking-tight">
            Privacy Policy
          </h1>
          <p className="text-sm sm:text-base text-[#94A3B8]">
            Last updated: September 2026
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12 text-[#CBD5E1] text-sm sm:text-base leading-relaxed">
          
          {/* Data Controller */}
          <div className="space-y-4">
            <h2 className="text-xl sm:text-2xl font-bold text-white tracking-tight">
              1. Data Controller
            </h2>
            <p>
              The entity responsible for processing your personal data on this website is:
            </p>
            <div className="p-5 rounded-xl bg-[#11141C] border border-[#202533] space-y-1 text-sm">
              <div className="font-semibold text-white">Prajwal Halwai</div>
              <div>CVR: 46152085</div>
              <div>Østerbro 7, 5000 Odense C, Denmark</div>
              <div>
                Email:{" "}
                <a href="mailto:prajwal@prajwalhalwai.com" className="text-[#CC3737] hover:underline">
                  prajwal@prajwalhalwai.com
                </a>
              </div>
              <div>
                Phone:{" "}
                <a href="tel:+4550382138" className="text-[#CC3737] hover:underline">
                  +45 50 38 21 38
                </a>
              </div>
            </div>
          </div>

          {/* Contact Form Submissions */}
          <div className="space-y-4">
            <h2 className="text-xl sm:text-2xl font-bold text-white tracking-tight">
              2. Contact Form Processing
            </h2>
            <p>
              When you submit an enquiry through our contact form, we collect the details you provide (such as your name, email address, phone number, and project description).
            </p>
            <p>
              This information is used exclusively to evaluate your enquiry, communicate with you directly regarding your project or question, and provide technical advisory. Submissions are transmitted directly to prajwal@prajwalhalwai.com and are not sold or transferred to third parties.
            </p>
          </div>

          {/* Consent Management - Cookiebot */}
          <div className="space-y-4">
            <h2 className="text-xl sm:text-2xl font-bold text-white tracking-tight">
              3. Consent Management (Cookiebot by Usercentrics)
            </h2>
            <p>
              This website employs Cookiebot by Usercentrics to manage visitor consent for cookies and third-party scripts. Where activated, Cookiebot ensures that non-essential scripts and third-party embeds are only initialized after your consent has been provided.
            </p>
            {/* Cookiebot Cookie Declaration */}
            <div className="pt-4">
              <div 
                ref={cookieDeclarationRef} 
                className="p-6 rounded-xl bg-[#11141C] border border-[#202533] text-sm text-[#CBD5E1] min-h-[120px] overflow-x-auto"
              >
                {/* Cookiebot injecter deklarationen her */}
              </div>
            </div>
          </div>

          {/* Testimonial Embeds - Senja */}
          <div className="space-y-4">
            <h2 className="text-xl sm:text-2xl font-bold text-white tracking-tight">
              4. Client Testimonials (Senja)
            </h2>
            <p>
              We display authentic client reviews and testimonials using the Senja platform (Senja.io). When the testimonial widget loads, technical data required to render the reviews securely (such as IP address and browser headers) may be processed by Senja in accordance with their privacy standards.
            </p>
          </div>

          {/* Newsletter - MailerLite */}
          <div className="space-y-4">
            <h2 className="text-xl sm:text-2xl font-bold text-white tracking-tight">
              5. Newsletter Subscription (MailerLite)
            </h2>
            <p>
              If you opt in to receive software insights or updates via our newsletter form, your email address is processed through MailerLite for distribution. You can unsubscribe at any time using the link included at the bottom of every newsletter email.
            </p>
          </div>

          {/* Web Hosting and Infrastructure */}
          <div className="space-y-4">
            <h2 className="text-xl sm:text-2xl font-bold text-white tracking-tight">
              6. Web Hosting & Infrastructure
            </h2>
            <p>
              This website is hosted on Auxo's cloud infrastructure (Auxo ApS) and served securely via Cloudflare's global content delivery network (CDN). When you access the website, essential server log data (such as IP address, browser user-agent, and requested URLs) is processed to ensure system stability, speed, and cybersecurity under GDPR Article 6(1)(f).
            </p>
          </div>

          {/* Your Rights */}
          <div className="space-y-4">
            <h2 className="text-xl sm:text-2xl font-bold text-white tracking-tight">
              7. Your Rights
            </h2>
            <p>
              Under applicable European data protection legislation (GDPR), you have the right to request access to, rectification of, or deletion of your personal data held by Prajwal Halwai. To exercise any of these rights, please contact prajwal@prajwalhalwai.com directly.
            </p>
          </div>

        </div>
      </section>
    </>
  );
}
